export default state => state.payment?.paymentOptionsLoadingStatus;
